import { render, staticRenderFns } from "./IndicationDetail.vue?vue&type=template&id=6c34a689&scoped=true"
import script from "./IndicationDetail.vue?vue&type=script&lang=js"
export * from "./IndicationDetail.vue?vue&type=script&lang=js"
import style0 from "./IndicationDetail.vue?vue&type=style&index=0&id=6c34a689&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c34a689",
  null
  
)

export default component.exports